const _state = {
    validationMessages: [],
    reportTypeSelected: '',
    filterText: '',
}

export const initialState = () => _state

export const state = initialState()